import { array, nullable, partial, record, string, union, UnknownRecord } from 'io-ts/Decoder';

import { StructuredIds as AncillaryItemStructuredIds } from '../../../../job/ancillary-item';
import { Id as RequirementId } from '../../../../job/requirement';
import { StructuredIds as SubAncillaryItemStructuredIds } from '../../../../job/sub-ancillary-item';
import { Datetime } from '../../../../time/Datetime';

/** @deprecated use DatetimeField instead */
const LegacyDatetime = nullable(string);
const DatetimeField = nullable(Datetime);
const LegacyOrNewDatetime = union(LegacyDatetime, DatetimeField);

export const Request = partial({
	transactionName: string,
	transactionRef: nullable(string),
	//
	timeline: record(LegacyOrNewDatetime),
	//
	bedcDifficultyRating: nullable(string),
	internalDifficultyRating: nullable(string),
	//
	customFormData: nullable(UnknownRecord),
	notes: nullable(string),
	//
	requirements: array(RequirementId),
	ancillaryItems: AncillaryItemStructuredIds,
	subAncillaryItems: SubAncillaryItemStructuredIds,
});
